import { render, staticRenderFns } from "./shetu-folder.vue?vue&type=template&id=76ef922a&scoped=true&"
import script from "./shetu-folder.vue?vue&type=script&lang=ts&"
export * from "./shetu-folder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ef922a",
  null
  
)

export default component.exports